import { createSlice } from "@reduxjs/toolkit";

const planningSlice = createSlice({
    name:'planning',
    initialState:{
        planningBuildPayload: null,
    },
    reducers: {
        setPlanningBuildPayload: (state, action) => {
            state.planningBuildPayload = action.payload; // Update state
        },
    },

})
export const { setPlanningBuildPayload } = planningSlice.actions;
export default planningSlice.reducer;